import React, { useEffect, useState, useRef } from "react";
import MainLayout from "../../Layout/mainLayout";
import Switch from "react-switch";
import { AddImageAll } from "../../Global Functions/addImage";
import { toast } from "react-hot-toast";
import { MdDeleteForever } from "react-icons/md";
import { FaEdit } from "react-icons/fa";
// import {
//   IoIosCloseCircleOutline,
//   IoMdInformationCircleOutline,
// } from "react-icons/io";
import { ReactComponent as PermissionSuccessfulIcon } from "../../Assets/Permissions/PermissionAddedSuccessfully.svg";
import axios from "axios";
// import { ReactComponent as CancelButton } from "../../Assets/Permissions/CancelButton.svg";
import { ReactComponent as PermissionIcon } from "../../Assets/Permissions/PermissionIcon.svg";
import { useDispatch, useSelector } from "react-redux";
// import TextInput from "../../Global Functions/textInput";
import {
  addRemovePermission,
  fetchPermission,
  updateAcl,
  removeAcl
} from "../../Redux/Actions/permissionAction";
import { getEnums } from "../../Redux/Actions/enumsActions";
import { ToFirstCapital } from "../../Utils/helpers";
// import { useFetcher } from "react-router-dom";

const PermissionMain = () => {
  const user = localStorage.getItem("userInfo")
    ? JSON.parse(localStorage.getItem("userInfo"))
    : "";
  const token = user ? user.data.token : "";
  axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

  const successCardRef = useRef(null);
  const dispatch = useDispatch();

  const BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const [managePermissions, setManagePermissions] = useState([]);
  const [newPermissionName, setNewPermissionName] = useState("");
  const [permissionImageUrl, setPermissionImageUrl] = useState("");
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deletePermissionId, setDeletePermissionId] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [tempPermissionData, setTempPermissionData] = useState({});

  const [showAddPermissionCard, setShowAddPermissionCard] = useState(false);
  const [showAdditionSuccessfulCard, setShowAdditionSuccessfulCard] =
    useState(false);
  const [editPermissionId, setEditPermissionId] = useState(null);

  const { permissions } = useSelector((state) => state.permissionList);
  const updateAclState = useSelector((state) => state.updateAcl || {});
  const removeAclState = useSelector((state) => state.removeAcl || {});
  const { enumsData } = useSelector((state) => state.enumsData || {});

  useEffect(() => {
    dispatch(fetchPermission());
    dispatch(getEnums());
  }, [dispatch]);

  const roles = enumsData?.data?.Roles
    ? Object.values(enumsData.data.Roles).map((value) => value)
    : [];

  const currentRole = useSelector((state) => state?.admin?.admin?.data?.role)
  console.log("Role", currentRole)
  // const path = useSelector((state) => state.admin)

  useEffect(() => {
    setManagePermissions(permissions?.data);
  }, [permissions]);

  const handleSwitchChange = async (permissionId, role, checked) => {
    setManagePermissions((prevPermissions) =>
      prevPermissions?.map((permission) =>
        permission._id === permissionId
          ? {
            ...permission,
            roles: {
              ...permission.roles,
              [role.toLowerCase()]: checked,
            },
          }
          : permission
      )
    );
    try {
      await dispatch(addRemovePermission(permissionId, role.toLowerCase(), checked));
      dispatch(fetchPermission());
    } catch (error) {
      console.error("Toggle update failed:", error);
    }
  };

  const handleDelete = (permissionId) => {
    setDeletePermissionId(permissionId);
    setShowDeleteModal(true);
  };

  const handleSaveUpdate = async () => {
    if (newPermissionName.trim() === "") {
      toast.error("Title is required");
      return;
    }
    if (!permissionImageUrl) {
      toast.error("Please upload an image");
      return;
    }

    try {
      await dispatch(updateAcl(tempPermissionData.id, permissionImageUrl));
      toast.success("Permission updated successfully");
      setShowAddPermissionCard(false);
      setNewPermissionName("");
      setPermissionImageUrl("");
      setIsEditing(false);
      setTempPermissionData({});
      setEditPermissionId(null);
      dispatch(fetchPermission());
    } catch (error) {
      toast.error("Update failed");
    }
  };

  const handleEdit = (permission) => {
    setIsEditing(true);
    setTempPermissionData({ id: permission._id, name: permission.name, image: permission.image });
    setNewPermissionName(permission.name);
    setPermissionImageUrl(permission.image);
    setShowAddPermissionCard(true);
  };

  const handleShowAddPermission = () => {
    setShowAddPermissionCard(true);
  };

  const hideShowAddPermission = () => {
    setShowAddPermissionCard(false);
    setNewPermissionName("");
    setPermissionImageUrl("");
    setIsEditing(false);
    setTempPermissionData({})
  };

  const handleAddPermissions = async () => {
    if (newPermissionName.trim() === "") {
      toast.error("Title is required");
      return;
    }
    if (!permissionImageUrl) {
      toast.error("Please upload an image");
      return;
    }

    const newPermission = {
      name: newPermissionName,
      image: permissionImageUrl
    };

    try {
      const response = await axios.post(`${BASE_URL}/acl/add`, newPermission, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.data.statusCode === 200) {
        setShowAdditionSuccessfulCard(true);
        setShowAddPermissionCard(false);
        setNewPermissionName("");
        setPermissionImageUrl("");
      } else {
        toast.error("Error adding permission: " + response.statusText);
      }
    } catch (error) {
      if (error.response) {
        toast.error("Backend Response Data:", error.response.data);
      } else {
        console.log("Error Message:", error.message);
      }
    }
  };

  useEffect(() => {
    if (updateAclState.success || removeAclState.success) {
      dispatch(fetchPermission());
    }
  }, [updateAclState.success, removeAclState.success, dispatch]);


  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        successCardRef.current &&
        !successCardRef.current.contains(event.target)
      ) {
        setShowAdditionSuccessfulCard(false);
      }
    };
    if (showAdditionSuccessfulCard) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showAdditionSuccessfulCard]);

  return (
    <MainLayout>
      <div style={{
        backgroundColor: '#ffffff',
        minHeight: '100vh',
        padding: '24px'
      }}>
        <div style={{
          backgroundColor: '#ffffff',
          borderRadius: '12px',
          border: '1px solid #e5e7eb',
          boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
        }}>
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '20px 24px',
            borderBottom: '1px solid #e5e7eb'
          }}>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '12px'
            }}>
              <PermissionIcon />
              <h1 style={{
                fontSize: '24px',
                fontWeight: '600',
                color: '#000000',
                margin: 0
              }}>
                Permissions
              </h1>
            </div>

            <button
              onClick={handleShowAddPermission}
              style={{
                backgroundColor: '#000000',
                color: '#ffffff',
                border: 'none',
                borderRadius: '8px',
                padding: '10px 20px',
                fontSize: '14px',
                fontWeight: '500',
                cursor: 'pointer',
                transition: 'background-color 0.2s'
              }}
              onMouseEnter={(e) => e.target.style.backgroundColor = '#333333'}
              onMouseLeave={(e) => e.target.style.backgroundColor = '#000000'}
            >
              {isEditing ? "Update Permission" : "Add Permission"}
            </button>
          </div>

          {showAddPermissionCard && (
            <div style={{
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              zIndex: 1000
            }}>
              <div style={{
                backgroundColor: '#ffffff',
                borderRadius: '12px',
                width: '90%',
                maxWidth: '400px',
                boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)'
              }}>
                <div style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  padding: '20px 24px',
                  borderBottom: '1px solid #e5e7eb'
                }}>
                  <h2 style={{
                    fontSize: '20px',
                    fontWeight: '600',
                    color: '#000000',
                    margin: 0
                  }}>
                    {isEditing ? "Edit Permission" : "Add Permission"}
                  </h2>
                  <button
                    onClick={hideShowAddPermission}
                    style={{
                      backgroundColor: 'transparent',
                      border: 'none',
                      fontSize: '24px',
                      color: '#6b7280',
                      cursor: 'pointer',
                      padding: '4px 8px',
                      lineHeight: 1
                    }}
                  >
                    ×
                  </button>
                </div>

                <div style={{ padding: '24px' }}>
                  <div style={{ marginBottom: '20px' }}>
                    <label style={{
                      display: 'block',
                      fontSize: '14px',
                      fontWeight: '500',
                      color: '#000000',
                      marginBottom: '8px'
                    }}>
                      Upload Image<span style={{ color: '#dc2626' }}>*</span>
                    </label>

                    <input
                      accept=".jpg,.jpeg,.png,.webp"
                      onChange={async (event) => {
                        const uploadedFile = event.target.files[0];
                        if (uploadedFile) {
                          const allowedTypes = [
                            "image/jpeg",
                            "image/jpg",
                            "image/png",
                            "image/webp",
                          ];
                          if (!allowedTypes.includes(uploadedFile.type)) {
                            toast.error("Only JPG, JPEG, PNG, and WebP files are allowed!");
                            event.target.value = "";
                            return;
                          }
                          try {
                            const responseUrl = await AddImageAll(uploadedFile);
                            if (responseUrl) {
                              setPermissionImageUrl(responseUrl);
                            }
                          } catch (error) {
                            toast.error("Upload failed");
                          }
                        }
                        event.target.value = "";
                      }}
                      id="permissionImage"
                      hidden
                      type="file"
                    />
                    <label
                      htmlFor="permissionImage"
                      style={{
                        display: 'inline-block',
                        backgroundColor: '#f3f4f6',
                        color: '#000000',
                        border: '2px dashed #d1d5db',
                        borderRadius: '8px',
                        padding: '12px 24px',
                        fontSize: '14px',
                        fontWeight: '500',
                        width: "86%",
                        cursor: 'pointer',
                        transition: 'all 0.2s',
                        textAlign: 'center'
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.backgroundColor = '#e5e7eb';
                        e.target.style.borderColor = '#9ca3af';
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.backgroundColor = '#f3f4f6';
                        e.target.style.borderColor = '#d1d5db';
                      }}
                    >
                      Click to Upload Image<span style={{ color: '#dc2626' }}>*</span>
                    </label>

                    {permissionImageUrl && (
                      <div style={{
                        position: "relative",
                        display: "inline-block",
                        marginTop: "12px"
                      }}>
                        <img
                          src={permissionImageUrl}
                          alt="Permission Preview"
                          style={{
                            width: "350px",
                            height: "112px",
                            objectFit: "contain",
                            background: "gray",
                            borderRadius: "8px",
                            border: "1px solid #e5e7eb"
                          }}
                        />
                        <button
                          onClick={() => setPermissionImageUrl("")}
                          style={{
                            position: "absolute",
                            top: "5px",
                            right: "5px",
                            backgroundColor: "transparent",
                            color: "white",
                            border: "none",
                            borderRadius: "50%",
                            width: "30px",
                            height: "30px",
                            cursor: "pointer",
                            fontSize: "18px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center"
                          }}
                        >
                          <p style={{ color: "black", fontSize: "25px" }}>×</p>
                        </button>
                      </div>
                    )}
                  </div>

                  <div style={{ marginBottom: '20px' }}>
                    <label
                      htmlFor="add-permission"
                      style={{
                        display: 'block',
                        fontSize: '14px',
                        fontWeight: '500',
                        color: '#000000',
                        marginBottom: '8px'
                      }}
                    >
                      Title<span style={{ color: '#dc2626' }}>*</span>
                    </label>
                    <input
                      id="add-permission"
                      type="text"
                      placeholder="Add Title..."
                      value={newPermissionName}
                      onChange={(e) => setNewPermissionName(e.target.value)}
                      style={{
                        width: '100%',
                        padding: '10px 12px',
                        fontSize: '14px',
                        color: '#000000',
                        backgroundColor: '#ffffff',
                        border: '1px solid #d1d5db',
                        borderRadius: '8px',
                        outline: 'none',
                        boxSizing: 'border-box'
                      }}
                      onFocus={(e) => e.target.style.borderColor = '#000000'}
                      onBlur={(e) => e.target.style.borderColor = '#d1d5db'}
                    />
                  </div>

                  <button
                    onClick={isEditing ? handleSaveUpdate : handleAddPermissions}
                    style={{
                      width: '100%',
                      backgroundColor: '#000000',
                      color: '#ffffff',
                      border: 'none',
                      borderRadius: '8px',
                      padding: '12px',
                      fontSize: '14px',
                      fontWeight: '500',
                      cursor: 'pointer',
                      transition: 'background-color 0.2s'
                    }}
                    onMouseEnter={(e) => e.target.style.backgroundColor = '#333333'}
                    onMouseLeave={(e) => e.target.style.backgroundColor = '#000000'}
                  >
                    Add Permission
                  </button>
                </div>
              </div>
            </div>
          )}

          {showAdditionSuccessfulCard && (
            <div
              ref={successCardRef}
              style={{
                position: 'fixed',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                backgroundColor: '#ffffff',
                borderRadius: '12px',
                padding: '32px',
                boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1)',
                textAlign: 'center',
                zIndex: 1001
              }}
            >
              <PermissionSuccessfulIcon />
              <h2 style={{
                fontSize: '18px',
                fontWeight: '600',
                color: '#000000',
                marginTop: '16px'
              }}>
                Permission Added Successfully
              </h2>
            </div>
          )}

          <div style={{ overflowX: 'auto' }}>
            <table style={{
              width: '100%',
              borderCollapse: 'collapse'
            }}>
              <thead>
                <tr style={{ backgroundColor: '#f9fafb' }}>
                  <th style={{
                    padding: '16px 24px',
                    textAlign: 'left',
                    fontSize: '14px',
                    fontWeight: '600',
                    color: '#000000',
                    borderBottom: '1px solid #e5e7eb'
                  }}>
                    Permissions
                  </th>
                  {roles.map((role) => (
                    <th
                      key={role}
                      style={{
                        padding: '16px 12px',
                        textAlign: 'center',
                        fontSize: '14px',
                        fontWeight: '600',
                        color: '#000000',
                        borderBottom: '1px solid #e5e7eb',
                        maxWidth: '70px',
                        whiteSpace: 'normal',
                        wordBreak: 'break-word',
                        lineHeight: '1.2'
                      }}
                    >
                      {ToFirstCapital(role.replace(/_/g, " "))}
                    </th>
                  ))}
                  <th style={{
                    padding: '16px 24px',
                    textAlign: 'center',
                    fontSize: '14px',
                    fontWeight: '600',
                    color: '#000000',
                    borderBottom: '1px solid #e5e7eb'
                  }}>
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody>
                {permissions?.data.map((permission) => {
                  return (
                    <tr key={permission._id}>
                      <td style={{
                        padding: '16px 24px',
                        fontSize: '14px',
                        color: '#000000',
                        borderBottom: '1px solid #e5e7eb'
                      }}>
                        <div
                          style={{
                            maxWidth: '140px',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            fontWeight: 700,
                          }}
                          title={permission.name}
                        >
                          {(() => {
                            const name =
                              permission.name.charAt(0).toUpperCase() + permission.name.slice(1);

                            return name.length > 18 ? `${name.substring(0, 18)}...` : name;
                          })()}
                        </div>
                      </td>

                      {roles.map((role) => (
                        <td
                          key={role}
                          style={{
                            padding: '16px 24px',
                            textAlign: 'center',
                            borderBottom: '1px solid #e5e7eb'
                          }}
                        >
                          <Switch
                            disabled={currentRole === "admin" || currentRole === "super_admin" ? false : true}
                            checked={permission.roles.some(
                              (r) =>
                                r.role.toLowerCase() === role.toLowerCase() &&
                                r.checked
                            )}
                            onChange={(checked) =>
                              handleSwitchChange(permission._id, role, checked)
                            }
                            id={`${permission._id}-${role}`}
                          />
                        </td>
                      ))}
                      <td style={{
                        padding: '16px 24px',
                        textAlign: 'center',
                        borderBottom: '1px solid #e5e7eb'
                      }}>
                        <div style={{
                          display: 'flex',
                          gap: '12px',
                          justifyContent: 'center',
                          alignItems: 'center'
                        }}>
                          {editPermissionId === permission._id ? (
                            <button style={{
                              backgroundColor: '#000000',
                              color: '#ffffff',
                              border: 'none',
                              borderRadius: '6px',
                              padding: '6px 12px',
                              fontSize: '13px',
                              cursor: 'pointer'
                            }}>
                              Save
                            </button>
                          ) : (
                            <FaEdit
                              style={{
                                fontSize: '18px',
                                color: '#000000',
                                cursor: 'pointer'
                              }}
                              onClick={() => handleEdit(permission)}
                            />
                          )}
                          <MdDeleteForever
                            style={{
                              fontSize: '22px',
                              color: '#dc2626',
                              cursor: 'pointer'
                            }}
                            onClick={() => handleDelete(permission._id)}
                          />
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      {showDeleteModal && (
        <div style={{
          position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.5)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          zIndex: 1002
        }}>
          <div style={{
            backgroundColor: '#ffffff', borderRadius: '12px',
            width: '90%', maxWidth: '400px', padding: '32px',
            textAlign: 'center', boxShadow: '0 20px 25px rgba(0,0,0,0.1)'
          }}>
            <h3 style={{ color: '#000000', fontSize: '20px', fontWeight: '600', marginBottom: '16px' }}>
              Delete Permission?
            </h3>
            <p style={{ color: '#6b7280', fontSize: '14px', marginBottom: '24px' }}>
              This action cannot be undone. Are you sure?
            </p>
            <div style={{ display: 'flex', gap: '12px', justifyContent: 'center' }}>
              <button
                onClick={() => setShowDeleteModal(false)}
                style={{
                  backgroundColor: '#f3f4f6', color: '#000000', border: 'none',
                  borderRadius: '8px', padding: '12px 24px', fontWeight: '500',
                  cursor: 'pointer', minWidth: '100px'
                }}
                onMouseEnter={(e) => e.target.style.backgroundColor = '#e5e7eb'}
                onMouseLeave={(e) => e.target.style.backgroundColor = '#f3f4f6'}
              >
                Cancel
              </button>
              <button
                onClick={async () => {
                  setShowDeleteModal(false);
                  try {
                    await dispatch(removeAcl(deletePermissionId));
                    toast.success('Permission deleted successfully');
                    dispatch(fetchPermission());
                  } catch (error) {
                    toast.error('Failed to delete permission');
                  }
                }}
                style={{
                  backgroundColor: '#dc2626', color: '#ffffff', border: 'none',
                  borderRadius: '8px', padding: '12px 24px', fontWeight: '500',
                  cursor: 'pointer', minWidth: '100px'
                }}
                onMouseEnter={(e) => e.target.style.backgroundColor = '#b91c1c'}
                onMouseLeave={(e) => e.target.style.backgroundColor = '#dc2626'}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}

    </MainLayout>
  );
};

export default PermissionMain;